import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import AppList from "../components/AppList";
import Header from "../components/Header";
import styles from "./AppListPage.module.css";
import premierIcon from "../assets/Premier_Membership_Icon.svg";
import Toggler from "components/Toggler";
import { useTranslation } from "react-i18next";

export function AppListPage() {
  const {t} = useTranslation();
  const history = useHistory();

  const [isToggled, setIsToggled] = useState(false);
  const apps = [
    {
      id: "1",
      name: t("DreamCast"),
    },
    {
      id: "2",
      name: t("Retail"),
    },
    {
      id: "3",
      name: t("Digital Info"),
    },
    {
      id: "4",
      name: t("Calendar"),
    },
    {
      id: "5",
      name: t("Local Functions"),
    },
    {
      id: "6",
      name: t("Contacts"),
    },
    {
      id: "7",
      name: t("Info Center"),
    },
    {
      id: "8",
      name: t("My Business"),
    },
    {
      id: "9",
      name: t("Getting Started"),
    },
    {
      id: "10",
      name: t("eReceipts"),
    },
    {
      id: "11",
      name: t("Spring Leadership"),
    },
    {
      id: "12",
      name: t("Family Reunion"),
    },
    {
      id: "13",
      name: t("Free Enterprise"),
    },
  ];

  const handleToggleChange = () => setIsToggled(!isToggled);
  const handleHeaderBackClick = () => {
    history.push("/");
  };
  return (
    <div className={styles.container}>
      <Header header={t("Settings")} onClick={handleHeaderBackClick} />
      <div className={styles.content}>
        <div>
          <p className={styles.header}>{t("Show Invite Button on Homescreen")}</p>
          <div className={styles.buttonContainer}>
            <div className={styles.premierContainer}>
              <img
                src={premierIcon}
                alt="Membership Icon"
                className={styles.premierIcon}
              />

              <p className={styles.textInvite}>{t("Invite New Premier Members")}</p>
            </div>

            <Toggler
              toggled={isToggled}
              onChange={handleToggleChange}
              color={isToggled ? "#39B54A" : "#D3D3D3"}
              visible={true}
              readOnly={false}
              disabled={false}
            />
          </div>
          <p className={styles.textNote}>
            {t("You can always access this button")}
          </p>
        </div>
        <AppList apps={apps} />
      </div>
    </div>
  );
}

export default AppListPage;
